import Vue from 'vue';
import VueRouter from 'vue-router';
import dotenv from 'dotenv';
import { roles } from '../helpers/utils';
dotenv.config();
Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/login' },
  {
    name: 'login',
    path: '/login',
    component: () => import('../views/Login.vue'),
  },
  {
    name: 'admin',
    path: '/admin',
    component: () => import('../views/admin/AdminDash.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'addcompany',
    path: '/admin/companies/new',
    component: () => import('../views/admin/AdminAddCompany.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'adminreports',
    path: '/admin/companies',
    component: () => import('../views/admin/companies/ViewCompanies.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'adminEditCompany',
    path: '/admin/companies/:id/edit',
    component: () => import('../views/admin/companies/EditCompany.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'companystats',
    path: '/admin/companies/:id',
    component: () => import('../views/admin/CompanyDash.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'adminsales',
    path: '/admin/admin-sales',
    component: () => import('../views/admin/sales/ViewSales.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'editadmin',
    path: '/admin-dashboard/edit-profile',
    component: () => import('../views/admin/EditAdmin.vue'),
    meta: { requiresAuth: true, roles: [roles.ADMIN, roles.SUPER_ADMIN] },
  },
  {
    name: 'supervisor',
    path: '/supervisor',
    component: () => import('../views/supervisor/SupervisorDash.vue'),
    meta: { requiresAuth: true, roles: [roles.SUPERVISOR] },
  },
  {
    name: 'addagents',
    path: '/supervisor/agents/new',
    component: () => import('../views/supervisor/AddAgent.vue'),
    meta: { requiresAuth: true, roles: [roles.SUPERVISOR] },
  },
  {
    name: 'supreports',
    path: '/supervisor/sales',
    component: () => import('../views/supervisor/SupReports.vue'),
    meta: { requiresAuth: true, roles: [roles.SUPERVISOR] },
  },
  {
    name: 'viewagents',
    path: '/supervisor/agents',
    component: () => import('../views/supervisor/agnets/ViewAgents.vue'),
    meta: { requiresAuth: true, roles: [roles.SUPERVISOR] },
  },
  {
    name: 'editsup',
    path: '/sup-dashboard/edit-profile',
    component: () => import('../views/supervisor/EditSupervisor.vue'),
    meta: { requiresAuth: true, roles: [roles.SUPERVISOR] },
  },
  {
    name: 'agent',
    path: '/agent',
    component: () => import('../views/agent/RecordSale.vue'),
    meta: { requiresAuth: true, roles: [roles.AGENT] },
  },
  {
    name: 'draftsales',
    path: '/agent/drafts',
    component: () => import('../views/agent/DraftSales.vue'),
    meta: { requiresAuth: true, roles: [roles.AGENT] },
  },
  {
    name: 'viewsales',
    path: '/agent/sales',
    component: () => import('../views/agent/ViewSales.vue'),
    meta: { requiresAuth: true, roles: [roles.AGENT] },
  },
  {
    name: 'editagent',
    path: '/agent-dashboard/edit-profile',
    component: () => import('../views/agent/EditAgent.vue'),
    meta: { requiresAuth: true, roles: [roles.AGENT] },
  },
  {
    name: 'PasswordReset',
    path: '/passwords/reset',
    component: () => import('../views/password/PasswordReset.vue'),
  },
  {
    name: 'PasswordUpdate',
    path: '/passwords/update',
    component: () => import('../views/password/PasswordUpdate.vue'),
  },
  {
    name: '401',
    path: '/unauthorized-access',
    component: () => import('../views/401page.vue'),
  },
  {
    name: '404',
    path: '/not-found',
    component: () => import('../views/404page.vue'),
  },
  { path: '*', redirect: '/not-found' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.meta.requiresAuth) {
    if (token === null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
      });
    } else {
      let user = JSON.parse(atob(token.split('.')[1]));
      if (to.meta.roles.includes(user.role)) {
        next();
      } else {
        next({ name: '401' });
      }
    }
  } else {
    next();
  }
});

export default router;
